import React, { useState } from 'react'

function Finished() {

    const logs = [1]

    const [today] = useState(new Date())
    const niceDateFormat = `${today.getDay()}/${today.getMonth()}/${today.getFullYear()}`

  return (
    <div>
      <form className='w-full text-black '>

        {logs.map((item) => {
            return (
                <div key={item} className='flex space-x-1 font-semibold my-3 bg-greenCustom px-2 py-1'>

                <div className='flex justify-center items-center bg-white rounded-md w-[25%] px-1'>
                <p className=''>{niceDateFormat}</p>
                </div>


                <div className='flex justify-center items-center px-1 w-[55%] bg-white rounded-md'>
                <p className=''>Post Project on PolicyWeb</p>
                </div>
                
                <div className='flex justify-center items-center bg-white rounded-md w-[20%] px-1'>
                    <p className=''>Veil</p>
                    </div>
                </div>
            )
        })}
      </form>
    </div>
  )
}

export default Finished
